import ReactGA from "react-ga4";

export const trackEvent = (eventName, params) => {
  if (typeof window !== "undefined" && typeof gtag === "function") {
    ReactGA.gtag("event", eventName, params ?? {});
  }
};

// Source = header | homepage | footer
export const clickBookButtonGA = (source) => {
  trackEvent("click_book_button", { source });
};

// Page = home | parks | hiw | faq | ferries
export const clickMainNavigationGA = (page) => {
  trackEvent("click_main_navigation", { page });
};

// Tab = start dates | accom | extras | cancellation protection
export const clickHIWTabGA = (tab) => {
  trackEvent("click_hiw_tab", { tab });
};

export const toggleMapGridViewGA = (showMapToggle) => {
  // Because grid is the default we have to invert the logic here
  // This is better than rewriting the main component
  const showMap = !showMapToggle;
  trackEvent("toggle_map_grid_view", { showMap });
};

export const bookFerryGA = (ferry) => {
  trackEvent("book_ferry", { ferry });
};

export const enableLargeTextGA = (large) => {
  trackEvent("enable_large_text", { large });
};

export const toggleRegionSliderGA = (showSlider) => {
  trackEvent("toggle_region_slider", { showSlider });
};

// Filtering
export const toggleFiltersOpenGA = (open) => {
  trackEvent("toggle_filters_open", { open });
};

export const selectCountryGA = (country) => {
  trackEvent("select_country_filter", { country });
};

export const selectRegionGA = (region) => {
  trackEvent("select_region_filter", { region });
};

export const selectOperatorGA = (operator) => {
  trackEvent("select_operator_filter", { operator });
};

export const toggleSavedParksGA = (filterOn) => {
  trackEvent("toggle_saved_parks_filter", { filterOn });
};

export const resetFiltersGA = () => {
  trackEvent("reset_all_filters");
};

// Park actions
// Tab = facilities | video | direction | accom
export const clickParkTabGA = (tab) => {
  trackEvent("click_park_tab", { tab });
};

export const openedParkGalleryGA = () => {
  trackEvent("opened_park_gallery");
};

export const clickedParkDirectionsGA = () => {
  trackEvent("clicked_park_directions");
};

export const toggleSavedParkGA = (parkId, saved) => {
  trackEvent("toggle_saved_park", { parkId, saved });
};

export const viewParkGA = (parkName, parkId) => {
  trackEvent("view_park", { parkName, parkId });
};

export const viewParkGalleryGridGA = () => {
  trackEvent("view_park_gallery_grid");
};

export const viewParkFullGalleryGA = () => {
  trackEvent("view_park_gallery_full");
};
